import OutputStateCardView from './OutputStateCardView.html';
import { ValueSource } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/Condition';
import { DEFAULT_VARIABLES_NAMES } from 'modules/application/detail/portal-submodule-builder/templates/builder/services/BuilderService';
import { BuilderFeatures } from '../../../../BuilderFeatures';
import { compareTexts } from '../../../../../../../../../../data/function';
import { OutputViewModel } from '../../../../models/viewModels/OutputViewModel';
import { OutputTypeStateId } from '../../../../models/Output';
import { v4 as uuidV4 } from 'uuid';
import { SURVEY_ID_PREFIX } from '../../../../services/BuilderStateService';
class OutputStateCard {
    static $inject = ['$timeout', '$element', '$translate', 'VariablesService', 'BuilderSegmentService', '$scope'];
    constructor($timeout, $element, $translate, VariablesService, BuilderSegmentService, $scope) {
        'ngInject';
        this.$timeout = $timeout;
        this.$element = $element;
        this.$translate = $translate;
        this.VariablesService = VariablesService;
        this.BuilderSegmentService = BuilderSegmentService;
        this.$scope = $scope;
        this.isDisabled = false;
        this.error = false;
        this.changeSwitchSurvey = async ({ detail }) => {
            if (detail.checked != this.isSwitchSurveyChecked) {
                this.isSwitchSurveyChecked = !this.isSwitchSurveyChecked;
                await this.updateStateDataOptions();
                this.onSelectOption(undefined);
                this.updateAddNewButton();
                this.updateSurveyTemplateTitle();
                if (this.isSwitchSurveyChecked) {
                    this.BuilderSegmentService.trackSatisfactionSurveyFiltered({
                        stateId: this.stateId,
                    });
                }
            }
        };
        this.addNewState = (value) => {
            const newOption = {
                id: `blip-select__option-${uuidV4()}`,
                value,
                label: value,
            };
            const oldTarget = this.oldStateId || '';
            const $data = {
                ...newOption,
                oldTarget,
            };
            if (this.onAddNewState) {
                this.onAddNewState({ $data });
            }
            this.addNewOptionOnDataOptions(newOption);
        };
        this.addNewSurvey = (value) => {
            if (!this.onAddNewSurvey) {
                return;
            }
            const $data = {
                template: value,
                oldTarget: this.oldStateId || '',
            };
            this.onAddNewSurvey({ $data });
            const newOption = {
                id: `blip-select__option-${uuidV4()}`,
                value: value,
                label: value,
            };
            this.addNewOptionOnDataOptions(newOption);
        };
        this.addNewOptionOnDataOptions = (newOption) => {
            this.$timeout(async () => {
                await this.updateStateDataOptions();
                const newTarget = this.stateDataOptions.find((s) => s.label === newOption.label);
                //when one state is created at the time of selecting a non-existent state, the "selectedStateId" property has undefined value
                //and so we need to assign the value to it
                if (!this.selectedStateId) {
                    this.selectedStateId = newTarget.value;
                }
                this.oldStateId = newTarget ? newTarget.value : '';
            });
        };
        this.addNewBlockData = {
            text: this.$translate.instant('builder-tabs-outputs.addNewState'),
        };
    }
    async $onInit() {
        await this.loadVariables();
        this.placeHolderContextVariable = await this.$translate('builder-tabs-outputs.target.contextVariable');
        this.placeHolderContextVariable = this.placeHolderContextVariable.replace('&#123;&#123;', '{{').replace('&#125;&#125;', '}}');
        this.contextHelp = await this.$translate('builder-tabs-outputs.target.contextHelp');
        this.contextHelp = this.contextHelp.replace('&#123;&#123;', '{{').replace('&#125;&#125;', '}}');
        this.isOutputVariableEnabled = await BuilderFeatures.outputVariableEnabled();
        if (!this.label) {
            this.label = await this.$translate('builder-tabs-outputs.goTo');
        }
        this.isSwitchSurveyChecked = this.isSurveyState(this.stateId);
        this.updateAddNewButton();
        this.updateSurveyTemplateTitle();
        await this.updateStateDataOptions();
        this.defineSelectedStateIdAndVariable();
        this.extraDataModel = {
            value: this.stateId || '',
            label: this.stateId ? this.states[this.stateId]?.$title : '',
        };
        this.oldStateId = this.selectedStateId;
    }
    addNewOption(value) {
        if (this.isSwitchSurveyChecked) {
            this.addNewSurvey(value);
        }
        else {
            this.addNewState(value);
        }
    }
    onSelectOption(value) {
        this.selectedStateId = value;
        this.changeTarget();
    }
    defineSelectedStateIdAndVariable() {
        if (OutputViewModel.isVariableValue(this.stateId)) {
            this.isVariableSelected = true;
            this.selectedStateId = ValueSource.Context;
            this.outputVariable = { name: this.stateId };
        }
        else if (this.stateId === ValueSource.Context) {
            this.isVariableSelected = true;
            this.outputVariable = { name: '' };
        }
        this.selectedStateId = OutputViewModel.isVariableValue(this.stateId) ? ValueSource.Context : this.stateId;
    }
    $onEdit($node) {
        this.onEdit({ $node });
    }
    async $onChanges(changesObj) {
        if (changesObj.states && !changesObj.states.isFirstChange()) {
            await this.updateStateDataOptions();
        }
        if (changesObj.isDisabled && !changesObj.isDisabled.isFirstChange()) {
            this.isDisabled = changesObj.isDisabled.currentValue;
        }
        if (changesObj.error && !changesObj.error.isFirstChange()) {
            this.error = changesObj.error.currentValue;
        }
    }
    changeTarget(event) {
        this.isVariableSelected = this.selectedStateId == ValueSource.Context;
        this.updateStates();
    }
    async updateAddNewButton() {
        this.buttonAddMessage = (this.isSwitchSurveyChecked) ?
            await this.$translate('builder-tabs-outputs.addNewSurvey') : await this.$translate('builder-tabs-outputs.addNewState');
    }
    async updateSurveyTemplateTitle() {
        this.surveyTemplateTitle = (this.isSwitchSurveyChecked) ? await this.$translate('builder-tabs-outputs.surveyTemplateTitle') : undefined;
    }
    isSurveyState(stateId) {
        return stateId ? stateId.startsWith(SURVEY_ID_PREFIX) : false;
    }
    filterSurveyState(state) {
        return this.showFilterSurvey && this.isSwitchSurveyChecked ? this.isSurveyState(state.id) : true;
    }
    async updateStateDataOptions() {
        this.stateDataOptions = convertToArray(this.states).filter(x => this.filterSurveyState(x)).map(convertToDataOptions);
        if (!(this.showFilterSurvey && this.isSwitchSurveyChecked)) {
            if (this.isOutputVariableEnabled && !this.filterSurvey && !this.isSurveyState(this.selectedStateId)) {
                await this.addDefaultVariableValue();
            }
        }
    }
    updateStates() {
        if (this.selectedStateId !== this.oldStateId) {
            const newTarget = this.selectedStateId;
            const oldTarget = this.oldStateId || '';
            const $data = {
                newTypeOfStateId: this.defineTypeOfStateId(newTarget),
                oldTypeOfStateId: this.defineTypeOfStateId(oldTarget),
                newTarget,
                oldTarget,
            };
            this.stateId = this.selectedStateId;
            this.outputChanged({ $data });
            this.oldStateId = this.selectedStateId;
        }
    }
    saveVariable() {
        const newTarget = this.outputVariable?.name ?? ValueSource.Context;
        if (newTarget !== this.stateId) {
            const oldTarget = this.stateId;
            this.stateId = newTarget;
            this.outputChanged({
                $data: {
                    newTypeOfStateId: OutputTypeStateId.Variable,
                    oldTypeOfStateId: this.defineTypeOfStateId(this.oldStateId || ''),
                    newTarget,
                    oldTarget,
                },
            });
            this.oldStateId = oldTarget;
        }
    }
    async loadVariables() {
        this.selectedVariable = this.outputVariable;
        this.variables = [
            ...DEFAULT_VARIABLES_NAMES.map((name) => ({ name: `{{${name}}}` })),
            ...this.VariablesService.userVariables.map((name) => ({ name: `{{${name}}}` })),
        ].sort(compareTexts);
    }
    async addDefaultVariableValue() {
        this.stateDataOptions = this.stateDataOptions.concat([{ value: ValueSource.Context, label: await this.$translate('builder-tabs-outputs.target.context') }]);
    }
    loadStates({ query, items }) {
        return items.filter((x) => x.label.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }
    onFocus() {
        this.editedOutput = this.selectedStateId;
    }
    onBlur() {
        if (this.editedOutput === this.selectedStateId) {
            const input = this.$element[0].querySelector('input');
            input.value = this.states[this.selectedStateId]
                ? this.states[this.selectedStateId].$title
                : '';
            input.dispatchEvent(new Event('input'));
            input.dispatchEvent(new CustomEvent('resetFilter'));
        }
    }
    onBlurVariable() {
        if (this.selectedStateId === ValueSource.Context
            && this.outputVariable?.name
            && !OutputViewModel.isVariableValue(this.outputVariable?.name)) {
            this.outputVariable = { name: ValueSource.Context };
            this.saveVariable();
        }
    }
    defineTypeOfStateId(target) {
        return target === ValueSource.Context ? OutputTypeStateId.Variable : OutputViewModel.defineTypeOfStateId(target);
    }
}
OutputStateCard.$inject = ['$timeout', '$element', '$translate', 'VariablesService', 'BuilderSegmentService', '$scope'];
export const convertToArray = (obj) => Object.keys(obj).reduce((acc, curr) => acc.concat(obj[curr]), []);
export const convertToDataOptions = (arr) => ({
    value: arr.id,
    label: arr.$title || arr.id,
});
export const OutputStateCardComponent = {
    controller: OutputStateCard,
    controllerAs: '$ctrl',
    template: OutputStateCardView,
    bindings: {
        stateId: '=',
        outputVariable: '<',
        states: '<',
        onEdit: '&?',
        outputChanged: '&',
        onAddNewState: '&?',
        onAddNewSurvey: '&?',
        showFilterSurvey: '<',
        isDisabled: '<',
        error: '<',
        label: '@?',
    },
};
